import type { ParsedBusiness } from "~/data/.server/business";
import { getStaticMap } from "~/lib/staticmaps";
import { capitalizeName } from "~/lib/utils";
import parsePhoneNumber from "libphonenumber-js";


function InfoSection(props: { title: string; children: React.ReactNode }) {
  if (!props.children) return null;
  return (
    <div className="prose-sm">
      <h3>{props.title}</h3>
      <p>{props.children}</p>
    </div>
  );
}

export function QuickInfoSection(props: {
  business: ParsedBusiness;
  latitude: number;
  longitude: number;
}) {
  const { business, latitude, longitude } = props;

  return (
    <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
      <div className="w-full overflow-clip flex items-center justify-center">
        <img
          alt={`Map of ${business.company?.basic?.name}`}
          style={{ aspectRatio: "1/1", height: "100%", width: "100%" }}
          src={getStaticMap({
            zoom: 14,
            width: 500,
            height: 500,
            markers: [[latitude, longitude]],
          })}
          className="m-0 overflow-clip object-cover"
          loading="lazy"
        />
      </div>
      <div className="space-y-2">
        <InfoSection title="Company Name">
          {capitalizeName(business.company?.basic?.name ?? "")}
        </InfoSection>
        <InfoSection title="Doing Business As">
          {capitalizeName(business.carrierInfo?.detail?.dbaName ?? "")}
        </InfoSection>
        <InfoSection title="Address">
          {capitalizeName(business.company?.address ?? "")}
        </InfoSection>
        <InfoSection title="Mailing Address">
          {capitalizeName(business.company?.mailingAddress ?? "")}
        </InfoSection>
        <InfoSection title="Phone">
          <a
            className="underline hover:text-primary"
            href={`tel:${business.company?.telephone}`}
          >
            {business.company?.telephone
              ? parsePhoneNumber(business.company.telephone)?.formatNational()
              : ""}
          </a>
        </InfoSection>
        <InfoSection title="Fax">
          {business.company?.fax
            ? parsePhoneNumber(business.company?.fax)?.formatNational()
            : ""}
        </InfoSection>
        <InfoSection title="Department of Transportation (DOT) #">
          {business.company?.dot}
        </InfoSection>
        <InfoSection title="Carrier Number (MC)">
          {business.company.mc}
        </InfoSection>
      </div>
    </div>
  );
}
